import { ArrowLeft } from 'react-feather'
import { useNavigate } from 'react-router-dom'

type BackButtonProps = {
  fallbackURI: string
  title?: string
}

export default function BackButton({ fallbackURI, title = 'Back' }: BackButtonProps) {
  const navigate = useNavigate()

  const handleBackClick = () => {
    if (typeof window !== 'undefined') {
      const { history } = window
      const state = history.state as { idx?: number } | null
      const hasRouterHistory = typeof state?.idx === 'number'
      const canNavigateBack = hasRouterHistory ? (state?.idx ?? 0) > 0 : history.length > 1

      if (canNavigateBack) {
        navigate(-1)
        return
      }
    }

    navigate(fallbackURI, { replace: true })
  }

  return (
    <div
      className="group flex gap-2 px-2 justify-center items-center cursor-pointer max-w-max transition-all"
      onClick={handleBackClick}
    >
      <ArrowLeft size={16} className="transition-colors group-hover:text-kodiak-text-primary" />
      <span className="text-sm font-medium text-kodiak-text-secondary transition-colors group-hover:text-kodiak-text-primary">
        {title}
      </span>
    </div>
  )
}
